import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Divider } from "primereact/divider";
import { addCompany, getCompanies } from "../../store/AsyncMethods/CompanyMethod"; 
import { useTranslation } from "react-i18next";
import { getTenants } from "../../store/AsyncMethods/TenantMethod";

export default function AddCompany() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  

  const {  user } = useSelector((state) => state.AuthReducer);
  const { allTenants } = useSelector((state) => state.TenantReducer);

  const formik = useFormik({
    initialValues: {
      company_name: "",
      tenant_id: "", 
    },
    validationSchema: Yup.object({
      company_name: Yup.string().required("Company Name Required"),
      tenant_id: Yup.string().required("Tenant ID Required"), 
    }),

    onSubmit: async (data) => {
      dispatch(addCompany(data)).then((success) => {
        if (success) {
          formik.resetForm();
          dispatch(getCompanies()); 
          navigate("/manage-companies"); 
        }
      });
    },
  });

 

  
        useEffect(() => {
          if (user) {
            dispatch(getTenants()); 
          }
        }, [user, dispatch]);

  return (
    <div className="mx-4">
      <div>
        <Button
          label={t("back")}
          icon="pi pi-arrow-left"
          className="p-black-btn"
          onClick={() => navigate(-1)}
        />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="card shadow-md rounded-lg p-4 mt-4">
          <Divider>
            <span className="text-2xl font-bold p-font-style text-center text-primary mx-1">
              {t("add_company")}
            </span>
          </Divider>

          <div className="px-4 gap-8 grid grid-cols-1 md:grid-cols-2">
            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="company_name" className="">
                  {t("company_name")}
                </label>
                <span className=" w-full">
                  <InputText
                    id="company_name"
                    name="company_name"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.company_name}
                    onChange={formik.handleChange}
                  />
                </span>
              </div>
              {formik.touched?.company_name && formik.errors?.company_name && (
                <div className="p-error">{formik.errors?.company_name}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="tenant_id" className="">
                  {t("select_tenant")}
                </label>
                <span className=" w-full">
                <Dropdown
                    id="tenant_id"
                    name="tenant_id"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.tenant_id}
                    onChange={formik.handleChange}
                    options={allTenants}
                    optionLabel={(option) => option.first_name + " " + option.last_name + " - [" + option.email + "]"}
                    optionValue="id"
                  />
                </span>
              </div>
              {formik.touched?.tenant_id && formik.errors?.tenant_id && (
                <div className="p-error">{formik.errors?.tenant_id}</div>
              )}
            </div>
          </div>
          <div className="mt-16">
            <div className="flex justify-end gap-4">
              <Button
                label={t("cancel")}
                icon="pi pi-times"
                className="p-red-btn"
                type="button"
                onClick={() => {
                  formik.resetForm();
                }}
              />
              <Button
                label={t("submit")}
                icon="pi pi-check"
                className="p-secondary-btn"
                type="submit"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
} 